export const BASE_API_DEV = "http://localhost:4000";
// export const BASE_API_DEV = "https://isms.impuls.run/api";

export const BASE_API_PROD = "https://smaitinsanmulia.api.isms.impuls.id";

export const SEKOLAH_KODE = "smaitinsanmulia";

export const APP_TIMEZONE = "Asia/Jakarta";
